/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */

export const traceIdUrl = (path, opts) => {
    let url = process.env.REACT_APP_TRACE_ID
    if (opts && opts.traceid_v2) {
        url = process.env.REACT_APP_TRACE_ID_BETA
    }
    return `${url}${path}`
}

export const traceIdMomentUrl = (profileHash, collectionHash, playlistClipId, opts) => {
    let url = process.env.REACT_APP_TRACE_ID
    if (opts && opts.traceid_v2 && collectionHash) {
        url = process.env.REACT_APP_TRACE_ID_BETA
        return `${url}/athlete/${profileHash}/list/${collectionHash}/item/${playlistClipId}`
    }
    return `${url}/athlete/${profileHash}/moments/${playlistClipId}`
}

export const GAMES_ROUTE='/:team_id'
export const gamesUrl = (teamId) => {
    return `/${teamId}`
}

export const GAME_OLD_COACH_ROUTE='/:team_id/games/:game_id/coach/notes/:event_number'
export const GAME_NEW_COACH_ROUTE='/:team_id/games/:game_id/coach-notes/notes/1'
export const GAME_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number'
export const gameUrl = (teamId, playlistId, gameId, eventNumber = 1) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}`
}


export const GAME_RADAR_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/radar'
export const gameRadarUrl = (teamId, playlistId, gameId, eventNumber = 1) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/radar`
}


export const GAME_NOTES_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/moments'
export const gameNotesUrl = (teamId, playlistId, gameId, eventNumber = 1) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/moments`
}

export const GAME_PLAYERS_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/players'
export const gamePlayersUrl = (teamId, playlistId, gameId, eventNumber = 1) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/players`
}

export const GAME_PLAYER_DETAILS_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/players/:player_id'
export const gamePlayerDetailsUrl = (teamId, playlistId, gameId, eventNumber, playerId) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/players/${playerId}`
}

export const ROSTER_LOGIN_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/players/:player_id/roster'
export const rosterLoginUrl = (teamId, playlistId, gameId, eventNumber, playerId) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/players/${playerId}/roster`
}

export const ROSTER_ADD_PLAYER_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/players/:player_id/roster/add'
export const rosterAddPlayerUrl = (teamId, playlistId, gameId, eventNumber, playerId) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/players/${playerId}/roster/add`
}

export const ROSTER_EDIT_PLAYER_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/players/:player_id/roster/edit/:player_id'
export const rosterEditPlayerUrl = (teamId, playlistId, gameId, eventNumber, traceNumber, playerId) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/players/${traceNumber}/roster/edit/${playerId}`
}

export const ROSTER_SWAP_PLAYER_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/players/:player_id/roster/swap'
export const rosterSwapPlayerUrl = (teamId, playlistId, gameId, eventNumber, traceNumber, playerId) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/players/${traceNumber}/roster/swap/${playerId}`
}

export const ROSTER_SWAP_PLAYER_ROUTE_TO='/:team_id/games/:game_id/:playlist_id/:event_number/players/:player_id/roster/swap/:to_team_player_id'
export const rosterSwapPlayerToUrl = (teamId, playlistId, gameId, eventNumber, playerId, teamPlayerId) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/players/${playerId}/roster/swap/${teamPlayerId}`
}

export const GAME_TEAM_DYNAMICS_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/dynamics'
export const gameTeamDynamicsUrl = (teamId, playlistId, gameId, eventNumber = 1) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/dynamics`
}

export const GAME_SHARE_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/share'
export const gameShareUrl = (teamId, playlistId, gameId, eventNumber = 1) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/share`
}

export const SAVE_MOMENT_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/save/profile'
export const saveMomentUrl = (teamId, playlistId, gameId, eventNumber = 1) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/save/profile`
}

export const GAME_SETTINGS_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/settings'
export const gameSettingsUrl = (teamId, playlistId, gameId, eventNumber = 1) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/settings`
}

export const TRACE_ID_PLUS_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/settings'
export const traceIdPlusUrl = (userHashKey, playlistHashKey, playlistClipId=null) => {
    let url = `/athlete/${userHashKey}/list/${playlistHashKey}`
    if (playlistClipId) url += `/item/${playlistClipId}/`
    return traceIdUrl(url)
}

export const GAME_OPTIONS_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/options'
export const gameOptionsUrl = (teamId, playlistId, gameId, eventNumber = 1) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/options`
}

export const GAME_DOWNLOAD_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/download'
export const gameDownloadUrl = (teamId, playlistId, gameId, eventNumber = 1) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/download`
}

export const PLAYER_SHARE_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/players/:player_id/share'
export const playerShareUrl = (teamId, playlistId, gameId, eventNumber, playerId) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/players/${playerId}/share`
}


export const DOWNLOAD_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/download'
export const downloadUrl = (teamId, playlistId, gameId, eventNumber) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/download`
}

export const BUY_ROUTE='/:team_id/games/:game_id/:playlist_id/:event_number/buy'
export const buyUrl = (teamId, playlistId, gameId, eventNumber) => {
    return `/${teamId}/games/${gameId}/${playlistId}/${eventNumber}/buy`
}

export const gameDownloadOnlyUrl = (teamId, gameId) => {
    return `/${teamId}/games/${gameId}/download-only`
}

export const QA_ROUTE='/:team_id/games/:game_id/qa/:playlist/:meta_type/:meta_value/:seq_num'
export const QA_ROUTE_SUFFIX='/:team_id/games/:game_id/qa/:playlist/:meta_type/:meta_value/:seq_num/:suffix'

export const GAME_BACK_ALT_ROUTE='/altback'

export const GO_TRACEUP_COM='https://go.traceup.com'
export const HELP_TRACEUP_COM='https://q.traceup.com'
export const PRIVACY_POLICY='https://traceup.com/privacy'
export const TERMS_OF_USE='https://go.traceup.com/terms'

export const getUrlExtras = url => {
    let extras = {}
    let parts = url.replace(/^#\//, '').split('/')
    let prevPart = null

    for (let i = 0; i < parts.length; i++) {
        let part = parts[i]
        if (i === 0) {
            extras.team_name = part
        }
        else if (i === 2) {
            extras.game_id = parseInt(part, 10)
        }
        else if (i === 3) {
            extras.playlist_id = part
        }
        else if (i === 4) {
            extras.event_number = part
        }
        else if (i > 4) {
            if (prevPart !== null) {
                extras[prevPart] = part
                prevPart = null
            } else {
                prevPart = part
            }
        }
    }
    if (prevPart !== null) {
        extras[prevPart] = prevPart
    }

    return extras
}
